var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "landing-title-extended" }, [
    _c("h1", {
      staticClass: "landing-title-extended__title",
      attrs: { "data-typo-type": "title" },
      domProps: { innerHTML: _vm._s(_vm.title) },
    }),
    _vm.subtitle
      ? _c(
          "h2",
          {
            staticClass: "landing-title-extended__subtitle",
            attrs: { "data-typo-type": "subtitle" },
          },
          [_vm._v(" " + _vm._s(_vm.subtitle) + " ")]
        )
      : _vm._e(),
    _vm.note
      ? _c(
          "h3",
          {
            staticClass: "landing-title-extended__note",
            attrs: { "data-typo-type": "note" },
          },
          [_vm._v(" " + _vm._s(_vm.note) + " ")]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }